// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// js utilities
import cx from 'classnames';

export default class ButtonGroupItem extends Component {
  static propTypes = {
    value: PropTypes.any.isRequired,
    selected: PropTypes.bool,
    id: PropTypes.any,
    disabled: PropTypes.bool,
    visible: PropTypes.bool,
    onClick: PropTypes.func
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <li
        className={cx('button-group-item noTextSelect', {active: this.props.selected, 'not-visible': !this.props.visible})}
        onClick={this.props.onClick}
        data-id={this.props.value}
      >
        {this.props.value}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_ButtonGroup/c_ButtonGroupItem/index.js